import React from 'react';
import WorkoutBlocksList from 'fit/pages/strength/WorkoutBlocksList';

const WorkoutBlocksListRoute =()=>{
    return (
            <WorkoutBlocksList/>
    )
}

export default WorkoutBlocksListRoute;